import { useEffect, useState } from 'react';
import nasmApi from '../api/endpoints';

export default function useFetchMuscleGroupsList () {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [muscleGroups, setMuscleGroups] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError(false);

    let isMounted = true;

    nasmApi.muscleGroups.getList().then(data => {
      if (isMounted) {
        setLoading(false);
        setError(false);
        setMuscleGroups(data.result);
      }
    })
      // eslint-disable-next-line handle-callback-err
      .catch(error => {
        if (isMounted) {
          setError(true);
          setLoading(false);
          setMuscleGroups([]);
        }
      });

    return () => { isMounted = false; };
  }, []);

  return { loading, error, muscleGroups };
}
